/**
 * Icon helper class (included by the helper service)
 *
 */
export class IconHelper {
    /**
     * Return a string containing the class to represent an icon according to the given extension
     *
     * @param extension
     * @returns {string}
     */
    public getIconClassFromExtension(extension) {
        switch (extension) {
            case 'doc':
            case 'docx':
                return 'fa fa-file-word-o';
            case 'csv':
            case 'xls':
            case 'xlsx':
                return 'fa fa-file-excel-o';
            case 'ppt':
            case 'pptx':
                return 'fa fa-file-powerpoint-o';
            case 'pdf':
                return 'fa fa-file-pdf-o';
            case 'txt':
                return 'fa fa-file-text-o';
            case 'avi':
            case 'flv':
            case 'mp4':
            case 'mkv':
            case 'webm':
                return 'fa fa-file-video-o';
            case 'flac':
            case 'ogg':
            case 'mp3':
            case 'wav':
                return 'fa fa-file-audio-o';
            case '7z':
            case 'bz2':
            case 'gz':
            case 'rar':
            case 'tar':
            case 'wim':
            case 'xz:':
            case 'zip':
                return 'fa fa-file-archive-o';
            case 'bat':
            case 'c':
            case 'class':
            case 'cpp':
            case 'css':
            case 'exe':
            case 'js':
            case 'h':
            case 'hpp':
            case 'html':
            case 'ini':
            case 'java':
            case 'jar':
            case 'json':
            case 'less':
            case 'php':
            case 'scss':
            case 'ts':
            case 'xml':
            case 'yaml':
                return 'fa fa-file-code-o';
            default:
                return 'fa fa-file-o';
        }
    }
}


// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/support/helpers/icon.helper.ts